import { onMounted, onUnmounted, ref } from 'vue'

export function useIsMobile() {
  const isMobile = ref(false)

  const updateWidth = () => {
    isMobile.value = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent) || window.innerWidth <= 768;
  }

  onMounted(() => {
    window.addEventListener('resize', updateWidth)
    updateWidth();
  })

  onUnmounted(() => {
    window.removeEventListener('resize', updateWidth)
  })

  return {
    isMobile
  }
}